import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {TaskService} from '../../../../services/task.service';
import { NzMessageService } from 'ng-zorro-antd/message';
@Component({
  selector: 'app-create-task-by-indicator-abnormal-status',
  templateUrl: './create-task-by-indicator-abnormal-status.component.html',
  styleUrls: ['../parts.css']
})
export class CreateTaskByIndicatorAbnormalStatusComponent implements OnInit {
  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据
  supervisoryStatus: string;
  supervisoryStatusText = '何';
  supervisoryStatusVisible = false;
  supervisoryVisible = false;
  supervisoryId: string;
  supervisoryDisplayText = '监控项';
  groupConditionVisible: boolean; // 分组POP是否关闭
  groupConditionId = null; // 分组选中ID
  groupConditionDisplayText = '分组';
  supervisoryData = [];
  supervisoryStatusData = [];
  isVisible = false; // 弹窗显示控制
  isConfirmLoading = false; // 确定按钮
  recipeId = null; // 自动化模板ID
  relationId = null;
  categorieId: string; // 存放当前目录ID
  instanceData: any = {}; // 存放实例返填数据
  backFillData: any;
  automation = {
    boardId: '',
    groupId: '',
    categoryId: '',
    relationId: '',
    indicatorItemId: '',
    indicatorExecutionStatus: '',
    instanceDescription: '',
    taskMapping: {},
    pulseMapping: {},
    conditions: []
  }; // 存放入参数据
  nodes = [];
  // 条件
  conditionData: any; // 存放条件筛选数据
  conditionVisible = false; // 条件pop
  selectConditionData = []; // 选中的条件
  source = 'indicator';
  conditionPopVisible = false;
  filterConditions = [];
  @ViewChild('pulseCard', { static: true }) pulseCard: any;
  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private taskService: TaskService,
    private message: NzMessageService
  ) { }

  ngOnInit(): void {
    if (this.boardData && JSON.stringify(this.boardData) !== '{}') {
      this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups : [];
      this.boardColumnData = this.boardData.boardData.columns ? this.boardData.boardData.columns : [];
      this.boardPulseData = this.boardData.boardData.pulses ? this.boardData.boardData.pulses : [];
    }
    this.getIndicatorItemsData();
    this.supervisoryStatusData = [
      // {
      //   id: 'normal',
      //   name: '正常'
      // },
      {
        id: 'abnormal',
        name: '异常'
      },
      // {
      //   id: 'in_progress',
      //   name: '扫描中'
      // },
      // {
      //   id: 'error',
      //   name: '错误'
      // },
      // {
      //   id: 'interrupt',
      //   name: '中断'
      // }
    ];
    // 处理返填数据
    // 反填分组
    this.groupConditionId = JSON.stringify(this.instanceData) !== '{}' ? this.instanceData.config.groupId : '';
    this.boardGroupData.forEach((item, index) => {
      if (item.id === this.groupConditionId) {
        this.groupConditionDisplayText = item.title;
      }
    });
    if (this.instanceData && this.instanceData.config) {
      // 触发发射事件
      this.automation = JSON.parse(JSON.stringify(this.instanceData.config));
      this.backFillData = this.automation.taskMapping;
    }
    // 带入菜单ID
    this.supervisoryId = this.automation.indicatorItemId;
    this.supervisoryStatus = this.automation.indicatorExecutionStatus;
    this.filterConditions = this.automation.conditions;
    this.automation.categoryId = this.categorieId;
    this.automation.relationId = this.relationId;
    this.supervisoryStatusData.forEach(item => {
      if (item.id === this.supervisoryStatus) {
        this.supervisoryStatusText = item.name;
      }
    });
    this.packageData();
  }
  openTaskDialog() {
    if (!this.supervisoryId) {
      this.message.create('warning', '请先选择监控项！');
      return;
    }
    this.isVisible = true;
  }
  // 获取任务创建数据
  getTaskIntegrationData(event) {
    // this.backFillData = event;
    const obj: any = {};
    event.forEach((item, index) => {
      let mapObj: any;
      if (typeof item.mappingValue === 'string') {
        switch (item.type) {
          case 'dropdown':
            mapObj = {
              'fixedValue': {
                'ids': [item.mappingValue]
              }
            };
            break;
          case 'select':
            mapObj = {
              'fixedValue': {
                'option': item.mappingValue
              }
            };
            break;
          case 'button':
            mapObj = {
              'fixedValue': {
                'original': item.mappingValue
              }
            };
            break;
        }
      }
      if (item.type === 'dropdown' || item.type === 'select' || item.type === 'button') {
        obj[item.id] = mapObj;
      } else {
        const mpArr = [];
        item.mappingValue.forEach((m, i) => {
          mapObj = {
            'type': 'field',
            'sourceField': {
              'id': m.id,
              'type': m.type ? m.type : 'text',
              'title': m.title
            }
          };
          mpArr.push(mapObj);
        });
        mpArr.unshift({'type': 'text', 'text': item.mappingFirstValue});
        mpArr.push({'type': 'text', 'text': item.mappingEndValue});
        obj[item.id] = {
          'targetField': {
            'id': item.id,
            'title': item.title,
            'type': item.type,
          },
          'mappingParts': mpArr
        };
      }
      this.automation.taskMapping['mappingConfig'] = obj;
    });
    this.packageData();
  }
  // 组件提交数据
  packageData() {
    this.automation.instanceDescription = '当监听到' + this.supervisoryDisplayText + '的状态为' + this.supervisoryStatusText + '时且满足条件时，在' + this.groupConditionDisplayText + '中，创建任务';
    this.nfDataChange.emit(this.automation);
  }
  // 获取当前提交状态，当所有必填项都填写时返回true
  getSubmitStatus(): boolean {
    return this.supervisoryId && this.filterConditions.length && this.supervisoryStatus &&
      this.groupConditionId &&
      JSON.stringify(this.automation.taskMapping) !== '{}';
  }
  // 弹窗确定事件
  handleOk() {
    this.pulseCard.onSubmit();
    this.isVisible = false;
  }
  // 弹窗关闭事件
  handleCancel() {
    this.isVisible = false;
  }
  supervisoryChange(item) {
    this.supervisoryData.forEach(list => {
      if (list.id === item) {
        this.supervisoryDisplayText = list.name;
      }
    });
    this.supervisoryId = item;
    this.supervisoryVisible = false;
    this.automation.indicatorItemId = this.supervisoryId;
    this.packageData();
  }
  supervisoryStatusChange(item) {
    this.supervisoryStatusText = item.name;
    this.supervisoryStatus = item.id;
    this.supervisoryStatusVisible = false;
    this.automation.indicatorExecutionStatus = this.supervisoryStatus;
    this.packageData();
  }
  groupConditionChange(item) {
    this.groupConditionDisplayText = item.title;
    this.groupConditionId = item.id;
    this.automation.groupId = this.groupConditionId;
    this.groupConditionVisible = false;
    this.packageData();
  }
  // 获取监控列表
  getIndicatorItemsData() {
    this.taskService.getIndicatorItems().subscribe((res: any) => {
      this.supervisoryData = res && res._embedded ? res._embedded.vos : [];
      if (this.supervisoryData && this.supervisoryData.length) {
        this.supervisoryData.forEach(item => {
          if (item.id === this.supervisoryId) {
            this.supervisoryDisplayText = item.name;
          }
        });
      }
    });
  }
  // 获取任务规则列表
  getTaskRuleListData() {
    const param = {
      page: 1,
      rows: 2000
    };
    this.taskService.getTaskList(param).subscribe((res: any) => {
      const data = res && res._embedded ? res._embedded.vos : [];
      this.nodes = this.handleTreeData(data);
      console.log(this.nodes);
    });
  }
  onTaskChange($event: string[]) {
    console.log($event);
  }
  handleTreeData(data) {
    data.forEach(item => {
      item.title = item.name;
      if (item.children && item.children.length) {
        this.handleTreeData(item.children);
      } else {
        item.isLeaf = true;
      }
    });
    return data;
  }
  // 获取条件数据
  getConditionData(data) {
    this.selectConditionData = data;
    this.packageData();
  }
  conditionPopChange() {
    if (!this.conditionPopVisible) {
      this.automation.conditions = this.filterConditions;
      this.packageData();
    }
  }
}
